export default __webpack_public_path__ + "static/media/Team.73b3313d.png";